import clsx from 'clsx';
import * as React from 'react';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { Tooltip } from 'react-tooltip';
import { AttributeResource } from '../../../../Types';
import { T, AlreadyTranslated } from '../../../../../../Translations';

interface Props {
  id: number;
  competencies: AttributeResource[];
}

const Competencies: React.FC<Props> = ({ id, competencies }) =>
  fromEmpty(competencies)
    .map((competencies) => (
      <>
        <div
          className="flex cursor-pointer items-end text-sm"
          data-tooltip-id={`${id}-competencies`}
        >
          <p className="underline decoration-teal-600 decoration-dashed">
            <T kind="{{count}} Competency" count={competencies.length} />
          </p>
        </div>
        <Tooltip
          id={`${id}-competencies`}
          style={{
            borderRadius: '6px',
            width: '250px',
            backgroundColor: 'white',
            padding: '16px',
            boxShadow:
              '0px 2px 4px 0px rgba(32, 37, 50, 0.03), 0px 2px 8px 0px rgba(32, 37, 50, 0.08)',
          }}
          openOnClick
          clickable
        >
          <div>
            {competencies.map((comp) =>
              comp.payload.name
                .map((name) => (
                  <p
                    className={clsx(
                      'mb-2 rounded border border-black text-xs',
                      'w-fit px-2 py-1 text-black last:mb-0',
                    )}
                    key={comp.payload.id}
                  >
                    <AlreadyTranslated content={name} />
                  </p>
                ))
                .getOrElse(() => <></>),
            )}
          </div>
        </Tooltip>
      </>
    ))
    .getOrElse(() => <></>);

export default observer(Competencies);
